import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=3556697e&scoped=true&"
import script from "./UserIcon.vue?vue&type=script&lang=js&"
export * from "./UserIcon.vue?vue&type=script&lang=js&"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=3556697e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556697e",
  null
  
)

export default component.exports